module.exports = __webpack_public_path__ + "static/flags/BI-abf3d9a58c23824004f3e5bc24bd1c39.gif";